import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { Col, FlexboxGrid, Popover } from 'rsuite';
import { isCompetitivenessLimitBroken, isMarginLimitBroken, normalizePercentageLimit } from './limitInfoUtils';

export const MarginLimitInfo = ({ content, margin, cpi, onMouseEnter, onMouseLeave, className, style }) => (
  <Popover onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={['popover-limite', className].filter(Boolean).join(' ')} style={style}>
    <div className="popover-limite__content">
      <h3 className="popover-limite__title">
        Informações de limite
        {!content?.minMargin && !content?.maxMargin ? <p>Não há limites de margem cadastrados para este produto</p> : null}
      </h3>
      {content?.minMargin || content?.maxMargin ? (
        // eslint-disable-next-line react/jsx-indent
        <FlexboxGrid justify="end">
          <FlexboxGrid.Item>
            <p className="popover-limite__description">LIMITE</p>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      ) : null}
      {(content?.minMargin || content?.maxMargin) && (content?.minCpi || content?.maxCpi) ? (
        <FlexboxGrid>
          <FlexboxGrid.Item componentClass={Col} lg={10} md={10} sm={10} xs={10}>
            <p
              className={
                isCompetitivenessLimitBroken(content, cpi) ? 'popover-limite__description popover-limite__description_invalid' : 'popover-limite__description'
              }
            >
              COMPETITIVIDADE
            </p>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} lg={14} md={14} sm={14} xs={14} className="popover-limite__section-value">
            <span className="popover-limite__text">{content.minCpi && !content.maxCpi ? 'ACIMA DE ' : ''}</span>
            <span className="popover-limite__text">{content.minCpi && content.maxCpi ? 'ENTRE ' : ''}</span>
            <span>
              {content.minCpi ? (
                <CurrencyFormat
                  fixedDecimalScale
                  decimalScale={2}
                  value={normalizePercentageLimit(content.minCpi)}
                  displayType="text"
                  suffix="%"
                  decimalSeparator=","
                  thousandSeparator="."
                />
              ) : (
                ''
              )}
            </span>
            <span className="popover-limite__text">{content.minCpi && content.maxCpi ? ' E ' : ''}</span>
            <span className="popover-limite__text">{!content.minCpi && content.maxCpi ? 'ATÉ ' : ''}</span>
            <span>
              {content.maxCpi ? (
                <CurrencyFormat
                  fixedDecimalScale
                  decimalScale={2}
                  value={normalizePercentageLimit(content.maxCpi)}
                  displayType="text"
                  suffix="%"
                  decimalSeparator=","
                  thousandSeparator="."
                />
              ) : (
                ''
              )}
            </span>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      ) : null}
      {content?.minMargin || content?.maxMargin ? (
        <FlexboxGrid>
          <FlexboxGrid.Item componentClass={Col} lg={10} md={10} sm={10} xs={10}>
            <p
              className={
                isMarginLimitBroken(content, margin) ? 'popover-limite__description popover-limite__description_invalid' : 'popover-limite__description'
              }
            >
              MARGEM
            </p>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} lg={14} md={14} sm={14} xs={14} className="popover-limite__section-value">
            <span className="popover-limite__text">{content.minMargin && !content.maxMargin ? 'ACIMA DE ' : ''}</span>
            <span className="popover-limite__text">{content.minMargin && content.maxMargin ? 'ENTRE ' : ''}</span>
            <span>
              {content.minMargin ? (
                <CurrencyFormat
                  fixedDecimalScale
                  decimalScale={2}
                  value={normalizePercentageLimit(content.minMargin)}
                  displayType="text"
                  suffix="%"
                  decimalSeparator=","
                  thousandSeparator="."
                />
              ) : (
                ''
              )}
            </span>
            <span className="popover-limite__text">{content.minMargin && content.maxMargin ? ' E ' : ''}</span>
            <span className="popover-limite__text">{!content.minMargin && content.maxMargin ? 'ATÉ ' : ''}</span>
            <span>
              {content.maxMargin ? (
                <CurrencyFormat
                  fixedDecimalScale
                  decimalScale={2}
                  value={normalizePercentageLimit(content.maxMargin)}
                  displayType="text"
                  suffix="%"
                  decimalSeparator=","
                  thousandSeparator="."
                />
              ) : (
                ''
              )}
            </span>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      ) : null}
    </div>
  </Popover>
);
